import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { GroupCardProps } from './GroupCardProps';

import * as styles from './GroupCard.module.scss';

export const GroupCard = ({ image, title }: GroupCardProps): JSX.Element => {
	return (
		<>
			<GatsbyImage className={styles.photo} image={image} alt={title} />
			<div className={styles.photoTitle}>{title}</div>
		</>
	);
};
